<template>
  <div>
    <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="$browserDetect && $browserDetect.isFirefox ? true : false
      " :preview-modal="false" :paginate-elements-by-height="1400" :filename="'Financial Report - ' +
    (this.$route.path.includes('sample')
      ? 'sample'
      : this.$route.params.id)
    " :pdf-quality="2" :manual-pagination="false" pdf-format="a4" pdf-orientation="landscape"
      pdf-content-width="1150px" ref="html2Pdf" @beforeDownload="beforeDownload($event)"
      @hasDownloaded="afterDownload($event)" @hasGenerated="afterDownload($event)">
      <section slot="pdf-content">
        <div class="pdf_docs report-pdf-file" ref="document" v-if="report">
          <section ref="page1" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="banner reprt-bnr page">
              <div class="section_body">
                <img src="/img/pdf_logo.png" alt="" class="company_logo" />
                <h1>Financial Report</h1>
                <h6>
                  [{{ parseInt(headerData.bznaics) }}] {{ headerData.industry }}
                </h6>
                <ul>
                  <li>
                    Market Area: <span>{{ headerData.area }}</span>
                  </li>
                  <li>
                    Sales Class: <span>{{ headerData.sales_class }}</span>
                  </li>
                  <li v-if="companyName">
                    Company Name:
                    <h6>
                      <span>{{ companyName }}</span>
                    </h6>
                  </li>
                  <li>
                    Release Date: <span>{{ releaseDisplay }}</span>
                  </li>
                </ul>
                <div class="bottom_area">
                  <div class="left">
                    <!--<h4>Company Name</h4>
                                        <div class="logo_wpr">
                                            <img src="/img/vivo_Energy.png" alt="">
                                            <h3>Vivo Energy Ltd.</h3>
                                        </div>-->
                  </div>
                  <div v-if="this.headerData.developer_name" class="right">
                    <h5>Developed By</h5>
                    <h3>{{ this.headerData.developer_name }}</h3>
                  </div>
                </div>
              </div>
              <div class="banner_footer">
                <!-- <h6>American Author</h6>-->
                <span class="author">
                  <!--Joyce Meyer-->
                </span>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
            </div>
          </section>
          <section ref="page2" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="company_info page">
              <div class="section_body">
                <ul>
                  <li>
                    <h5>About the Data</h5>
                    <p>Value of Bizminer Reports</p>
                  </li>
                  <li>
                    <h5>Summary Scores</h5>
                    <p>
                      Summary Scores All Years (Scale 1-5) <br />Worth Your
                      Focus <br />Ratio Categories <br />Cash-Flow <br />Profit
                      <br />Efficiency <br />Debt
                    </p>
                  </li>
                  <li>
                    <h5>Industry Summary</h5>
                    <p>
                      Industry Peer Group <br />Industry In Context: The NAICS
                      Classification System
                    </p>
                  </li>
                  <li>
                    <h5>Financials</h5>
                    <p>
                      Income Statement <br />Balance Sheet <br />Sources &amp;
                      Uses of Funds
                    </p>
                  </li>
                  <li>
                    <h5>Ratios</h5>
                    <p>
                      Cash Flow Solvency <br />Profitability <br />Efficiency
                      <br />Cash Debt Risk
                    </p>
                  </li>
                  <li>
                    <h5>Valuation Multiples</h5>
                    <p>
                      Sales Group: &#60; $2.5m <br />Sales Group: $2.5m - $24.9m
                      <br />Sales Group: &#62; $25m <br />Sales Group: All
                    </p>
                  </li>
                </ul>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
          <section ref="page3" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info page">
              <div class="section_body">
                <div class="section_title">
                  <h2>About the Data</h2>
                  <span class="date">{{
                    moment(new Date()).format("MMM Do YYYY")
                  }}</span>
                </div>
                <div class="data_box_about">
                  <p>
                    Bizminer data is widely accepted for industry analytical
                    work, benchmarking, valuations, forensics and litigation.
                    Bizminer content is accepted in US Tax Court (Bauer vs. IRS:
                    T.C. Memo. 2012-156) and is utilized by state, provincial
                    and national taxing agencies in the US and Canada.
                  </p>
                  <p>
                    Raw data analyzed for Bizminer reports is sourced from an
                    array of the nation's government and private statistical
                    sources. None of these raw data sources creates the final
                    measures reflected in Bizminer industry profiles. In total,
                    Bizminer accesses over a billion sourced data points from 15
                    million business operations for each of its twice annual
                    updates covering a 3-5 year time series. Historical data and
                    Bizminer algorithms are used to inform and test projections
                    for non-reporting firms. Data elements are sourced
                    specifically from:
                  </p>
                </div>
                <div class="list_box">
                  <ul>
                    <li>IRS SOI Corporation Tax Book</li>
                    <li>IRS Statistics of Income</li>
                    <li>US Economic Census</li>
                    <li>US Census Quarterly Financial Reports</li>
                    <li>US Census County Business Patterns</li>
                    <li>
                      Bureau of Labor Statistics Monthly Employment Reports
                    </li>
                    <li>
                      Bureau of Labor Statistics Monthly Unemployment Reports
                    </li>
                    <li>Bureau of Labor Statistics Annual Wage Survey</li>
                    <li>Bureau of Labor Statistics Industry</li>
                    <li>Reports</li>
                    <li>Bureau of Labor Statistics Price Indices</li>
                    <li>National Agricultural Statistical Service</li>
                    <li>US Census Quarterly Financial Reports</li>
                    <li>US Census Retail Trade Report</li>
                    <li>Data Axle</li>
                    <li>Business Valuation Resources (BVR)</li>
                    <li>Credit Reporting Agencies</li>
                    <li>Business Directories</li>
                    <li>American Community Survey</li>
                  </ul>
                </div>
                <div class="about_bottom">
                  <p>
                    While 100% firm coverage is desirable for analysis purposes,
                    the greatest value of Bizminer reports rests in discerning
                    patterns of activity, which are reflected in the large
                    samples used to develop our reports. The overall current
                    coverage of the databases surpasses 13 million active
                    business operations at any point in time.
                  </p>
                  <p>
                    As is the case with any databases this large, some errors
                    are inevitable. Some firms are missed and specific
                    information on others is lacking from the database. Not all
                    information received is uniform or complete, resulting in
                    the need to develop projection algorithms for specific
                    industry segments and metrics in some report series. No
                    representation is made as to the accuracy of the databases
                    utilized or the results of subsequent analyses.
                  </p>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
          <section ref="page4" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score summary-score page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Summary Score</h2>
                  <span class="date">{{
                    moment(new Date()).format("MMM Do YYYY")
                  }}</span>
                </div>
                <div class="md-layout pt-4">
                  <div v-if="summaryScoreChartData" class="md-layout-item md-size-100">
                    <DonutChart :chartdata="summaryScoreChartData" />
                    <div class="score-donut-overlay">
                      <div class="heading">SWOT<br />Overall Score</div>
                      <div class="score">{{ overallScore }}/5</div>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-100 p-0">
                    <h5>Summary Scores All Years (Scale 1-5)</h5>
                    <p class="small">
                      Based on your inputs, the Industry Financial Report
                      calculates the percentage difference (variance) between
                      client ratios and the industry average for the selected
                      industry peer group. Your firm performance on each ratio
                      is scored on a 1-5 scale (5 being best) for each year
                      displayed in the report. The scoring approach depends on
                      the specific scored ratio. You can find a detailed
                      explanation for each at the end of this report.
                    </p>
                    <p class="small">
                      The value of peer comparisons with your business depends
                      on the accuracy and completeness of the firm financial
                      information that is being entered. The more detail that
                      you provide, the more comprehensive and meaningful the
                      benchmark.
                    </p>
                    <p class="small">
                      For each ratio, the score for those years selected from
                      the most recent three calendar years is averaged and
                      integrated into a Ratio Category Score. The Score for each
                      of the four categories (Cash Flow/Solvency; Profitability;
                      Efficiency; Debt-Risk) are then averaged to produce an
                      Overall Score.
                    </p>

                    <md-table v-if="this.display_summary_scores && this.summaryScoresAll
                      " v-model="summaryScoresAll" table-header-color="blue" class="mb-2 mt-4">
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Title">
                          {{ item.title }}
                        </md-table-cell>
                        <md-table-cell md-label="Score">
                          {{ item.rating }}
                        </md-table-cell>
                        <md-table-cell md-label="Rating" class="td-actions text-right">
                          <div class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(item.rating)" :key="i + item.title">{{ v }}</md-icon>
                          </div>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                    <!-- </div> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="worthYourFocusPage" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score summary-score page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Worth Your Focus</h2>
                </div>
                <div class="md-layout pt-4">
                  <div class="md-layout-item md-size-100 p-0">
                    <div class="md-layout">
                      <div class="md-layout-item">
                        <h5>Worth Your Focus:</h5>
                        <p class="small">
                          Ratio Category scores are simply a reflection of the
                          more focused individual ratios that they include. Any
                          ratios that score below 3.0 should be examined closely
                          for weaknesses in management or performance that could
                          be improved with reasonable effort and expense. While
                          you should work with a qualified advisor to obtain
                          specific guidance, we’ve flagged these areas for
                          attention:
                        </p>
                      </div>
                    </div>
                    <div v-if="worthYourFocus" class="md-layout score mt-4">
                      <div class="md-layout-item md-size-100">
                        <h5 class="table_header purple-bg">Worth Your Focus</h5>
                      </div>
                    </div>
                    <md-table v-if="worthYourFocus" v-model="worthYourFocus" table-header-color="blue"
                      class="w-100 no_head">
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label>
                          {{ item.title }}
                        </md-table-cell>
                        <md-table-cell md-label>
                          {{ parseFloat(item.rating).toFixed(2) }}
                        </md-table-cell>
                        <md-table-cell md-label class="td-actions">
                          <div class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(item.rating)" :key="i + item.title">{{ v }}</md-icon>
                          </div>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                    <!-- </div> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page5" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score page">
              <div class="section_body">
                <div class="negetive_margin" v-if="SCText">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 mb-2">
                      <div class="tble-box">
                        <div class="tbl-title">
                          <h4>Ratio Categories</h4>
                        </div>
                        <p class="pl-2 pr-2">
                          The Bizminer Industry Financial Report is based on
                          selected financial ratios that are typically
                          considered to be Key Performance Indicators (KPIs)
                          which includes:
                        </p>
                        <div class="inner-tbl">
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Cash Flow/Solvency:</h4>
                            <p>
                              Cash Flow ratios indicate a company's ability to
                              meet various levels of demand on cash and easily
                              obtainable cash resources against current and
                              anticipated near-term payments due.
                            </p>
                          </div>
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Profitability:</h4>
                            <p>
                              Profitability ratios compare levels of return
                              against various expense and balance sheet
                              components to measure your performance against
                              reasonable industry peer group standards,
                              indicating bottom line performance,
                            </p>
                          </div>
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Efficiency:</h4>
                            <p>
                              Efficiency ratios measure your success in
                              marshalling resources at hand to effectively
                              manage various components of your business
                              operations. These indicators often point most
                              specifically toward actions that could enhance
                              your bottom line.
                            </p>
                          </div>
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Debt-Risk:</h4>
                            <p>
                              Debt-Risk ratios assess the appropriateness of a
                              firm’s level of debt against the ability to pay,
                              as well as the risk of insolvency.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="md-layout-item md-size-100 mb-2">
                      <div class="tble-box">
                        <div class="tbl-title">
                          <h4>Cash-Flow</h4>
                        </div>
                        <div class="inner-tbl">
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>About Ratios:</h4>
                            <p>{{ SCText.cashflow1 }}</p>
                          </div>
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Industry Comparison:</h4>
                            <p>{{ SCText.cashflow2 }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page6" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score page">
              <div class="section_body">
                <div class="negetive_margin" v-if="SCText">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 mb-2">
                      <div class="tble-box">
                        <div class="tbl-title">
                          <h4>Profit</h4>
                        </div>
                        <div class="inner-tbl">
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>About Income Data:</h4>
                            <p>{{ SCText.profit1 }}</p>
                          </div>
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Industry Comparison:</h4>
                            <p>{{ SCText.profit2 }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="md-layout-item md-size-100 mb-2">
                      <div class="tble-box">
                        <div class="tbl-title">
                          <h4>Efficiency</h4>
                        </div>
                        <div class="inner-tbl">
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>About Efficiency:</h4>
                            <p>{{ SCText.effi1 }}</p>
                          </div>
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Efficiency Comparison:</h4>
                            <p>{{ SCText.effi2 }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="md-layout-item md-size-100 mb-2">
                      <div class="tble-box">
                        <div class="tbl-title">
                          <h4>Debt</h4>
                        </div>
                        <div class="inner-tbl">
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>About Debt Data:</h4>
                            <p>{{ SCText.debt1 }}</p>
                          </div>
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Industry Comparison:</h4>
                            <p>{{ SCText.debt2 }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page7" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="insight_sec competitor_sec page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Industry Summary</h2>
                  <span class="date">{{
                    moment(new Date()).format("MMM Do YYYY")
                  }}</span>
                </div>
                <div class="table_sec">
                  <div class="tbl-title">
                    <p>Industry Peer Group</p>
                  </div>
                  <p>
                    When you accessed your Industry Financial Report, you
                    selected a comparison peer group that most closely
                    represents the character of your firm.
                  </p>
                  <div class="negetive_margin">
                    <div class="md-layout">
                      <div v-if="tableData" class="md-layout-item md-size-50">
                        <md-table v-model="tableData" table-header-color="blue">
                          <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="Profile Year">
                              {{ item.year }}
                            </md-table-cell>
                            <md-table-cell md-label="Firms">
                              {{ item.firms }}
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </div>
                      <div class="md-layout-item md-size-50">
                        <!-- <BarChart v-if="industrySummaryChart"
                                                    :categories="industrySummaryChart.labels"
                                                    :chartdata="industrySummaryChart.series" /> -->

                        <LineChart v-if="industrySummaryChart" :categories="industrySummaryChart.labels"
                          :chartdata="industrySummaryChart.series" />
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-100 mt-4 pt-4 mb-4">
                        <div class="tbl-title">
                          <h4>
                            Your Industry In Context: The NAICS Classification
                            System
                          </h4>
                        </div>
                        <div class="white_space">
                          <p>
                            The industry your selected fits within the official
                            NAICS (North American Industry Classification
                            System) and Bizminer's proprietary taxonomy, which
                            breaks out more detailed industries classifications
                            than NAICS by adding up to eight decimal digits
                            after the NAICS-6 code. The industry you selected
                            fits into this industry hierarchy:
                          </p>
                          <ul>
                            <li v-for="(value, key) in naicsDrilldown" :key="key">
                              NAICS: {{ key }} - {{ value }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page8" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Industry Financials</h2>
                </div>
                <div>
                  <h6 class="mt-2 mb-2">Income Statement</h6>
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Percentages</h4>
                    </div>
                    <div v-if="tableDataFirmPercent" class="inner-tbl">
                      <md-table v-model="tableDataFirmPercent" table-header-color="blue" class="dark_blue"
                        style="flex: 1;">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell :md-label="headerData.client_name" :class="item.name === 'Cost of Sales - Labor Portion'
                              ? 'md-table-side-label pl-2'
                              : 'md-table-side-label'
                            ">
                            {{ item.name }}
                          </md-table-cell>

                          <!-- <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                    header-animation="false"
                                                    :chart-data="newChartFirmPercentOptions[item.name].data"
                                                    :chart-options="chartOptions"
                                                    chart-type="Line"
                                                    header-icon
                                                    chart-inside-content
                                                    no-footer
                                                    background-color="blue"
                                                ></chart-card>
                                                </md-table-cell> -->

                          <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">
                            {{ item.dates[key] }}%
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page9" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <!-- <div class="section_title">
                                    <h2>Industry Financials</h2>
                                </div> -->
                <div>
                  <!-- <h4>Income Statement</h4> -->
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Percentages</h4>
                    </div>
                    <div v-if="tableDataIndustryPercent" class="inner-tbl">
                      <md-table v-model="tableDataIndustryPercent" table-header-color="blue" class="dark_blue"
                        style="flex: 1;">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label="Industry" :class="item.name === 'Cost of Sales - Labor Portion'
                              ? 'md-table-side-label pl-2'
                              : 'md-table-side-label'
                            ">
                            {{ item.name }}
                          </md-table-cell>

                          <!-- <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                    header-animation="false"
                                                    :chart-data="newChartIndustryPercentOptions[item.name].data"
                                                    :chart-options="chartOptions"
                                                    chart-type="Line"
                                                    header-icon
                                                    chart-inside-content
                                                    no-footer
                                                    background-color="blue"
                                                ></chart-card>
                                                </md-table-cell> -->

                          <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">
                            {{ item.dates[key] }}%
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page10" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <!-- <div class="section_title">
                                    <h2>Industry Financials</h2>
                                </div> -->
                <div>
                  <!-- <h4>Income Statement</h4> -->
                  <div class="tble-box">
                    <div class="tbl-title ">
                      <h4>Dollars ( All figures in USD )</h4>
                    </div>
                    <div v-if="tableDataFirmDollar" class="inner-tbl">
                      <md-table v-model="tableDataFirmDollar" table-header-color="blue" class="dark_blue"
                        style="flex: 1;">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell :md-label="headerData.client_name" :class="item.name === 'Cost of Sales - Labor Portion'
                              ? 'md-table-side-label pl-2'
                              : 'md-table-side-label'
                            ">
                            {{ item.name }}
                          </md-table-cell>
                          <!-- <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                    header-animation="false"
                                                    :chart-data="newChartFirmDollarOptions[item.name].data"
                                                    :chart-options="chartOptions"
                                                    chart-type="Line"
                                                    header-icon
                                                    chart-inside-content
                                                    no-footer
                                                    background-color="blue"
                                                ></chart-card>
                                                </md-table-cell> -->

                          <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">
                            ${{ item.dates[key] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page11" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <!-- <div class="section_title">
                                    <h2>Industry Financials</h2>
                                </div> -->
                <div>
                  <!-- <h4>Income Statement</h4> -->
                  <div class="tble-box">
                    <div class="tbl-title ">
                      <h4>Dollars ( All figures in USD )</h4>
                    </div>
                    <div v-if="tableDataIndustryDollar" class="inner-tbl">
                      <md-table v-model="tableDataIndustryDollar" table-header-color="blue" class="dark_blue"
                        style="flex: 1;">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label="Industry" :class="item.name === 'Cost of Sales - Labor Portion'
                              ? 'md-table-side-label pl-2'
                              : 'md-table-side-label'
                            ">
                            {{ item.name }}
                          </md-table-cell>

                          <!-- <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                    header-animation="false"
                                                    :chart-data="newChartIndustryDollarOptions[item.name].data"
                                                    :chart-options="chartOptions"
                                                    chart-type="Line"
                                                    header-icon
                                                    chart-inside-content
                                                    no-footer
                                                    background-color="blue"
                                                ></chart-card>
                                                </md-table-cell> -->

                          <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">
                            ${{ item.dates[key] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page12" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <!-- <div class="section_title">
                                    <h2>Industry Financials</h2>
                                </div> -->
                <div>
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Variance</h4>
                    </div>
                    <div v-if="tableDataVarianceDollar" class="inner-tbl">
                      <md-table v-model="tableDataVarianceDollar" table-header-color="blue" class="dark_blue"
                        style="flex: 1;">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell :md-label="headerData.client_name" :class="item.name === 'Cost of Sales - Labor Portion'
                              ? 'md-table-side-label pl-2'
                              : 'md-table-side-label'
                            ">
                            {{ item.name }}
                          </md-table-cell>

                          <!-- <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                    header-animation="false"
                                                    :chart-data="newChartVarianceDollarOptions[item.name].data"
                                                    :chart-options="chartOptions"
                                                    chart-type="Line"
                                                    header-icon
                                                    chart-inside-content
                                                    no-footer
                                                    background-color="blue"
                                                ></chart-card>
                                                </md-table-cell> -->

                          <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">
                            {{ item.dates[key] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page13" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <!-- <div class="section_title">
                                    <h2>Industry Financials</h2>
                                </div> -->
                <div>
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Charts ( All figures in USD )</h4>
                    </div>
                    <div class="inner-tbl">
                      <md-card class="m-0">
                        <md-card-content>
                          <div class="md-layout light_border mb-2">
                            <div v-for="(chart, i) in charts" :key="i" :class="'md-layout-item md-medium-size-100 md-size-50 mt-2 ' +
                              formatTitleToClass(chart.title)
                              ">
                              <div class="tbl-title">
                                <h4>{{ chart.title }}</h4>
                              </div>
                              <chart-card header-animation="false" :chart-data="chart.data"
                                :chart-options="getOptions(chart.options)" chart-type="Pie" header-icon
                                chart-inside-content background-color="blue">
                                <template slot="footer">
                                  <div class="md-layout">
                                    <div class="md-layout-item">
                                      <span v-for="(v, i) in chart.options
                                            .legendNames" :key="i" :class="`ct-series-${i}`">
                                        <i class="fa fa-circle"></i>
                                        {{ v }} ({{
                                          chart.options.labelInterpolationSignFn(
                                            chart.data.series[i]
                                          )
                                        }})
                                      </span>
                                    </div>
                                  </div>
                                </template>
                              </chart-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page14" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="pl_definitions_sec page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Profit Loss Definitions</h2>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-50 pl-0 pr-0">
                    <p>
                      <b>Business Revenue</b> includes receipts from core
                      business operations. Interest Income and Other income
                      (such as rents and royalties) are generally detailed
                      separately below Operating Income. While Business Revenue
                      is separated from Interest Income for most
                      classifications, Business Revenue includes interest income
                      from the private sector where it is central to financial
                      industry operations, including Finance and Insurance
                      (NAICS 52xxxx except NAICS 5242xx Insurance Brokers and
                      Other Insurance Activities); Real Estate-Rental-Leasing
                      (53xxxx); and Management of Companies and Enterprises
                      (55xxxxx).
                    </p>
                    <p>
                      <b>Cost of Sales</b> includes materials and labor involved
                      in the direct delivery of a product or service. Other
                      costs are included in the cost of sales to the extent that
                      they are involved in bringing goods to their location and
                      condition ready to be sold. Non-production overheads such
                      as development costs may be attributable to the cost of
                      goods sold. The costs of services provided will consist
                      primarily of personnel directly engaged in providing the
                      service, including supervisory personnel and attributable
                      overhead.
                    </p>
                    <p>
                      <b>Cost of Sales-Labor:</b> The payroll compensation
                      portion of Cost of Sales, expressed as a per cent of
                      Business Revenue.
                    </p>
                    <p>
                      <b>Gross Margin</b> represents direct operating expenses
                      plus net profit. In addition to the labor portion of Cost
                      of Sales, payroll costs are reflected in the Officers
                      Compensation and Wages-Salary line items. In many cases,
                      SG&A (Sales, General and Administrative) costs also
                      include some overhead, administrative and supervisory
                      wages.
                    </p>
                    <p>
                      <b>Officers Compensation:</b> Salary, wages stock bonuses
                      and other compensation paid to officers for personal
                      services rendered. It does not include qualified deferred
                      compensation, such as contributions to a 401(k) plan or a
                      salary reduction agreement, which are included in the
                      Benefits-Pensions line.
                    </p>
                    <p>
                      <b>Compensation and Wages-Salary</b> line items. In many
                      cases, SG&A (Sales, General and Administrative) costs also
                      include some overhead, administrative and supervisory
                      wages.
                    </p>
                    <p>
                      <b>Rent</b> covers the rental cost of any business
                      property, including land, buildings and equipment.
                    </p>
                  </div>
                  <div class="md-layout-item md-size-50 pr-0">
                    <p>
                      The <b>Taxes Paid</b> line item includes payroll other
                      paid-in tax items, but not business income taxes due for
                      the period. Although it can be calculated in many ways and
                      is not a formal measure, the EBITDA line item (Earnings
                      before Interest Expense, income tax due, Depreciation and
                      Amortization) adds back interest payments, depreciation,
                      amortization and depletion allowances, and excludes income
                      taxes due to reduce the effect of accounting decisions on
                      the bottom line of the Profit and Loss Statement. Since
                      some firms utilize EBITDA to "add back" non-cash and
                      flexible expenses which may be altered through credits and
                      accounting procedures (such as income tax), paid-in income
                      taxes from the Taxes Paid line item are not added back in
                      the EBITDA calculation.
                    </p>
                    <p>
                      <b>Advertising</b> includes advertising, promotion and
                      publicity for the reporting business, but not on behalf of
                      others.
                    </p>
                    <p>
                      <b>Benefits-Pension</b> includes, but is not limited to,
                      employee health care and retirement costs.
                    </p>
                    <p>
                      In addition to varying proportions of overhead,
                      administrative and supervisory wages, some generally more
                      minor expenses are aggregated under SG&A (<b>Sales, General and Administrative</b>).
                    </p>
                    <p>
                      <b>EBITDA:</b> Business Revenue: Earnings Before Interest,
                      (income) Taxes due, Depreciation and Amortization divided
                      by Business Revenue. EBITDA: Business Revenue is a
                      relatively controversial (and often criticized) metric
                      designed to eliminate the effect of finance and accounting
                      decisions when comparing companies and industry
                      benchmarks. Tax credits and deferral procedures and
                      non-cash expenditures (Amortization and Depreciation) are
                      not deducted from the profit equation, as are interest
                      expenditures.
                    </p>
                    <p>
                      <b>Operating Expenses</b> sums the individual expense line
                      items above, yielding the Operating Income or net of core
                      business operations, when subtracted from the Gross
                      Margin.
                    </p>
                    <p>
                      <b>Pre-Tax Net Profit</b> represents net profit before
                      income tax due. Income Tax calculates the federal
                      corporate tax rate before credits, leaving After-Tax
                      Profit at the bottom line.
                    </p>
                    <p>
                      <b>Discretionary Owner Earnings</b> sums Officer
                      Compensation, Depreciation and related non-cash expenses
                      and Net Profit before business taxes to represent a
                      practical measure of total return to owners. The D.O.E.
                      metric is mainly used for small businesses.
                    </p>
                  </div>
                </div>
                <!-- <IFPdfSourcesUsers /> -->
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page15" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Industry Financials</h2>
                </div>
                <div>
                  <h6 class="mt-2 mb-2">Balance Sheet</h6>
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Percentages</h4>
                    </div>
                    <div v-if="tableDataFirmPercentBalanceSheet" class="inner-tbl">
                      <md-table v-model="tableDataFirmPercentBalanceSheet" table-header-color="blue" class="dark_blue"
                        style="flex: 1;">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell :md-label="headerData.client_name" :class="item.name === 'Cost of Sales - Labor Portion'
                              ? 'md-table-side-label pl-2'
                              : 'md-table-side-label'
                            ">
                            {{ item.name }}
                          </md-table-cell>

                          <!-- <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                    header-animation="false"
                                                    :chart-data="newChartFirmPercentOptions[item.name].data"
                                                    :chart-options="chartOptions"
                                                    chart-type="Line"
                                                    header-icon
                                                    chart-inside-content
                                                    no-footer
                                                    background-color="blue"
                                                ></chart-card>
                                                </md-table-cell> -->

                          <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">
                            {{ item.dates[key] }}%
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page16" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <!-- <div class="section_title">
                                    <h2>Industry Financials</h2>
                                </div> -->
                <div>
                  <!-- <h4>Income Statement</h4> -->
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Percentages</h4>
                    </div>
                    <div v-if="tableDataIndustryPercentBalanceSheet" class="inner-tbl">
                      <md-table v-model="tableDataIndustryPercentBalanceSheet" table-header-color="blue" class="dark_blue"
                        style="flex: 1;">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label="Industry" :class="item.name === 'Cost of Sales - Labor Portion'
                              ? 'md-table-side-label pl-2'
                              : 'md-table-side-label'
                            ">
                            {{ item.name }}
                          </md-table-cell>

                          <!-- <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                    header-animation="false"
                                                    :chart-data="newChartIndustryPercentOptions[item.name].data"
                                                    :chart-options="chartOptions"
                                                    chart-type="Line"
                                                    header-icon
                                                    chart-inside-content
                                                    no-footer
                                                    background-color="blue"
                                                ></chart-card>
                                                </md-table-cell> -->

                          <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">
                            {{ item.dates[key] }}%
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page17" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <!-- <div class="section_title">
                                    <h2>Industry Financials</h2>
                                </div> -->
                <div>
                  <!-- <h4>Income Statement</h4> -->
                  <div class="tble-box">
                    <div class="tbl-title ">
                      <h4>Dollars ( All figures in USD )</h4>
                    </div>
                    <div v-if="tableDataFirmDollarBalanceSheet" class="inner-tbl">
                      <md-table v-model="tableDataFirmDollarBalanceSheet" table-header-color="blue" class="dark_blue"
                        style="flex: 1;">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell :md-label="headerData.client_name" :class="item.name === 'Cost of Sales - Labor Portion'
                              ? 'md-table-side-label pl-2'
                              : 'md-table-side-label'
                            ">
                            {{ item.name }}
                          </md-table-cell>
                          <!-- <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                    header-animation="false"
                                                    :chart-data="newChartFirmDollarOptions[item.name].data"
                                                    :chart-options="chartOptions"
                                                    chart-type="Line"
                                                    header-icon
                                                    chart-inside-content
                                                    no-footer
                                                    background-color="blue"
                                                ></chart-card>
                                                </md-table-cell> -->

                          <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">
                            ${{ item.dates[key] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page18" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <!-- <div class="section_title">
                                    <h2>Industry Financials</h2>
                                </div> -->
                <div>
                  <!-- <h4>Income Statement</h4> -->
                  <div class="tble-box">
                    <div class="tbl-title ">
                      <h4>Dollars ( All figures in USD )</h4>
                    </div>
                    <div v-if="tableDataIndustryDollarBalanceSheet" class="inner-tbl">
                      <md-table v-model="tableDataIndustryDollarBalanceSheet" table-header-color="blue" class="dark_blue"
                        style="flex: 1;">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label="Industry" :class="item.name === 'Cost of Sales - Labor Portion'
                              ? 'md-table-side-label pl-2'
                              : 'md-table-side-label'
                            ">
                            {{ item.name }}
                          </md-table-cell>

                          <!-- <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                    header-animation="false"
                                                    :chart-data="newChartIndustryDollarOptions[item.name].data"
                                                    :chart-options="chartOptions"
                                                    chart-type="Line"
                                                    header-icon
                                                    chart-inside-content
                                                    no-footer
                                                    background-color="blue"
                                                ></chart-card>
                                                </md-table-cell> -->

                          <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">
                            ${{ item.dates[key] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page19" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <!-- <div class="section_title">
                                    <h2>Industry Financials</h2>
                                </div> -->
                <div>
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Variance</h4>
                    </div>
                    <div class="inner-tbl" v-if="tableDataVarianceDollarBalanceSheet">
                      <md-table v-model="tableDataVarianceDollarBalanceSheet" table-header-color="blue" class="dark_blue"
                        style="flex: 1;">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell :md-label="headerData.client_name" :class="item.name === 'Cost of Sales - Labor Portion'
                              ? 'md-table-side-label pl-2'
                              : 'md-table-side-label'
                            ">
                            {{ item.name }}
                          </md-table-cell>

                          <!-- <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                    header-animation="false"
                                                    :chart-data="newChartVarianceDollarOptions[item.name].data"
                                                    :chart-options="chartOptions"
                                                    chart-type="Line"
                                                    header-icon
                                                    chart-inside-content
                                                    no-footer
                                                    background-color="blue"
                                                ></chart-card>
                                                </md-table-cell> -->

                          <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">
                            {{ item.dates[key] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page20" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <!-- <div class="section_title">
                                    <h2>Industry Financials</h2>
                                </div> -->
                <div>
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Charts ( All figures in USD )</h4>
                    </div>
                    <div class="inner-tbl">
                      <md-card class="m-0">
                        <md-card-content>
                          <div class="md-layout light_border px-4 mb-2">
                            <div v-for="(chart, i) in chartsBalanceSheet" :key="i" :class="'md-layout-item md-medium-size-100 md-size-50 mt-2 ' +
                              formatTitleToClass(chart.title)
                              ">
                              <div class="tbl-title">
                                <h4>{{ chart.title }}</h4>
                              </div>
                              <chart-card header-animation="false" :chart-data="chart.data"
                                :chart-options="getOptions(chart.options)" chart-type="Pie" header-icon
                                chart-inside-content background-color="blue">
                                <template slot="footer">
                                  <div class="md-layout">
                                    <div class="md-layout-item">
                                      <span v-for="(v, i) in chart.options
                                            .legendNames" :key="i" :class="`ct-series-${i}`">
                                        <i class="fa fa-circle"></i>
                                        {{ v }} ({{
                                          chart.options.labelInterpolationSignFn(
                                            chart.data.series[i]
                                          )
                                        }})
                                      </span>
                                    </div>
                                  </div>
                                </template>
                              </chart-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page21" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div id="page9" class="pl_definitions_sec page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Balance Sheet Definitions</h2>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <h4>
                      <b>Cash:</b> Money on hand in checking, savings or
                      redeemable certificate accounts.
                    </h4>
                    <h4>
                      <b>Receivables:</b> A short-term asset (to be collected
                      within one year) in the form of accounts or notes
                      receivable, and usually representing a credit for a
                      completed sale or loan.
                    </h4>
                    <h4><b>Inventory:</b> The stockpile of unsold products.</h4>
                    <h4>
                      <b>Current Assets:</b> The sum of a firm's cash, accounts
                      and notes receivable, inventory, prepaid expenses and
                      marketable securities which can be converted to cash
                      within a single operating cycle.
                    </h4>
                    <h4>
                      <b>Fixed Assets:</b> Long-term assets such as building and
                      machinery, net of accumulated
                      amortization-depreciation-depletion.
                    </h4>
                    <h4>
                      <b>Total Assets:</b> The sum of current assets and fixed
                      assets such as plant and equipment. Note: Some legacy year
                      asset line items are blended with the closest four-digit
                      industry segment. In local Industry Financial report, some
                      legacy year asset line item percentages are applied
                      directly from US averages for this industry. Local
                      percentages may differ. Other balance sheet percentages
                      and all balance sheet dollar calculations are based on
                      actual local data.
                    </h4>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <h4>
                      <b>Accounts Payable:</b> Invoices due to suppliers within
                      the current business cycle.
                    </h4>
                    <h4>
                      <b>Loans/Notes Payable:</b> Loan amounts due to suppliers
                      within the current business cycle.
                    </h4>
                    <h4>
                      <b>Current Liabilities:</b> Measurable debt owed within
                      one year, including accounts, loans and notes payable,
                      accrued liabilities and taxes due.
                    </h4>
                    <h4>
                      <b>Total Liabilities:</b> Current Liabilities plus Long
                      Term Liabilities such as notes and mortgages due over more
                      than one year.
                    </h4>
                    <h4>
                      <b>Long Term Liabilities:</b> which is due in more than
                      one year, including the portion of loans and mortgages
                      that become due after the current business cycle.
                    </h4>
                    <h4>
                      <b>Total Liabilities:</b> Current Liabilities plus Long
                      Term Liabilities such as notes and mortgages due over more
                      than one year.
                    </h4>
                    <h4>
                      <b>Net Worth:</b> Current assets plus fixed assets minus
                      current and long-term liabilities.
                    </h4>
                  </div>
                </div>
                <!-- <IFPdfSourcesUsers /> -->
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page22" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <IFRPDFSourcesUsers :headerInfo="headerData" />
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page23" slot="pdf-content" class="pdf_docs prfl-pdf">
            <!-- <div class="industry_financials_sec page"> -->
            <IFRPDFRatios :headerInfo="headerData" />
            <!-- <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p> -->
            <!-- </div> -->
          </section>

          <section ref="page24" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="value_multiples page">
              <div class="section_body">
                <div class="section_title mb-2">
                  <h2>Valuation Multiples</h2>
                </div>
                <div class="negetive_margin">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <h3 class="sub_header mt-4">About Valuation Multiples</h3>

                      <h4>
                        <b>Business Value Insight Terms</b>: The Bizminer
                        Valuations Value basis is derived from projected company
                        sales; peer group average earnings %; and industry
                        valuation multiples. Median ranges reflect a range of
                        market conditions and business performance at this
                        revenue scale.<br /><br />
                        You should not use Bizminer Valuations in place of a
                        professional valuation or as the basis of any specific
                        business-related or other financial transaction; nor to
                        secure a business or personal loan.<br /><br />
                        <b>Owner Earnings (Cash Flow) Approach:</b>
                        Revenue/Owner Earnings market valuation approach<br /><br />
                        <b>Sales Approach:</b> Revenue/Annual Sales market value
                        approach<br /><br />
                        <b>Note:</b> Median is the point at which 50% of a
                        sample is above and 50% of the same below the value.
                        Quartile 1 lies at the mid-point between the median and
                        the lowest value; Quartile 3 between the median and the
                        highest value.
                      </h4>
                    </div>
                    <div v-if="tableInfo" class="md-layout-item md-size-50">
                      <h5>Sales Group: &#60; $2.5m</h5>
                      <md-table v-model="tableInfo" table-header-color="blue">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label>
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples">
                            {{ multiplesA[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples">
                            {{ multiplesA[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                    <div v-if="tableInfo" class="md-layout-item md-size-50">
                      <h5>Sales Group: $2.5m - $24.9m</h5>
                      <md-table v-model="tableInfo" table-header-color="blue">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label>
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples">
                            {{ multiplesB[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples">
                            {{ multiplesB[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                    <div v-if="tableInfo" class="md-layout-item md-size-50 mt-2">
                      <h5>Sales Group: &#62; $25m</h5>
                      <md-table v-model="tableInfo" table-header-color="blue">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label>
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples">
                            {{ multiplesC[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples">
                            {{ multiplesC[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                    <div v-if="tableInfo" class="md-layout-item md-size-50 mt-2">
                      <h5>Sales Group: All</h5>
                      <md-table v-model="tableInfo" table-header-color="blue">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label>
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples">
                            {{ multiplesAll[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples">
                            {{ multiplesAll[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
        </div>
      </section>
    </VueHtml2pdf>
  </div>
</template>
<script>
import { ChartCard } from "@/components";
import VueHtml2pdf from "vue-html2pdf";
import { mapState } from "vuex";
import ratingMixin from "@/mixins/rating-mixin";
import formatData from "@/mixins/format-data";
import IFRPDFSourcesUsers from "./IFRPDFSourcesUsers.vue";
import IFRPDFRatios from "./IFRPDFRatios.vue";
// import BarChart from '@/components/BarChart.vue';
import LineChart from "@/components/LineChart.vue";
import DonutChart from "@/components/DonutChart.vue";
// import GoogleMapLoader from "@/pages/Dashboard/Components/GoogleMapLoader.vue";
import moment from "moment";

export default {
  components: {
    VueHtml2pdf,
    ChartCard,
    IFRPDFSourcesUsers,
    IFRPDFRatios,
    // BarChart,
    LineChart,
    DonutChart,
    // GoogleMapLoader
  },
  props: ["headerData", "user"], //, 'imrFile2', 'compet', 'market', 'annual', 'covid', 'penetration', 'employment', 'salesEmp','years','Productivity','startups','cessation','ownership'],
  mixins: [ratingMixin, formatData],
  data() {
    return {
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          // lineSmooth: this.$Chartist.Interpolation.cardinal({
          //   tension: 10,
          // }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "auto",
        },
      },
      tableData: [],
      filtered_years: ['"Firms Analyzed"'],
      filtered_firms: [""],
      convertData: [],
      tableInfo: [
        {
          id: "Low",
          name: "Q1",
        },
        {
          id: "Med",
          name: "Median",
        },
        {
          id: "High",
          name: "Q3",
        },
      ],
      moment: moment,

      tableDataIndustryDollar: [],
      tableDataIndustryDollarBalanceSheet: [],
      tableDataIndustryPercent: [],
      tableDataIndustryPercentBalanceSheet: [],
      tableDataFirmDollar: [],
      tableDataFirmDollarBalanceSheet: [],
      tableDataFirmPercent: [],
      tableDataFirmPercentBalanceSheet: [],
      tableDataVarianceDollar: [],
      tableDataVarianceDollarBalanceSheet: [],
      newChartFirmPercentOptions: [],
      newChartFirmPercentOptionsBalanceSheet: [],
      newChartIndustryPercentOptions: [],
      newChartIndustryDollarOptions: [],
      newChartFirmDollarOptions: [],
      newChartVarianceDollarOptions: [],
      summaryChartData: [],
      scoreChartOptions: {
        donut: true,
        showLabel: false,
        legendNames: [],
        // labelInterpolationFnc: (value) => value + '$',
        height: "150px",
        width: "150px",
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5,
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6,
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
      chartOptions: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 1,
        }),
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5,
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6,
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
      charts: [],
      chartsBalanceSheet: [],
      chartsChunks: [],
      chartsChunksBalanceSheet: [],
      options: {
        donut: true,
        showLabel: false,
        legendNames: [],
        height: "150px",
      },
      display_by_dollars: true,
      display_by_percentages: true,
      display_by_variance: true,
      display_summary_scores: true,
      multipleBarsChart: {
        data: {
          labels: [ // TODO: make this automatic.
            "Jan 2019",
            "July 2019",
            "Jan 2020",
            "July 2020",
            "Jan 2021",
          ],
          series: [
            [0.8, 1.4, 1.8, 2.5, 2.2],
            [0.9, 1.3, 2.0, 2.8, 2.6],
            [1.1, 1.6, 2.3, 2.1, 3.0],
            [1.4, 1.2, 2.5, 2.2, 2.8],
            [1.2, 1.2, 2.8, 1.8, 2.4],
            [1.2, 1.7, 1.8, 1.9, 2.5],
          ],
        },
        options: {
          seriesBarDistance: 19,
          high: 4,
          axisX: {
            showGrid: false,
          },
          axisY: {
            offset: 80,
            labelInterpolationFnc: function (value) {
              return "$" + value + "M";
            },
          },
          height: "150px",
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
      industrySummaryChart: null,
      summaryScoreChartData: null,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    headerInfo() { },
    report(newVal, oldVal) {
      this.init();
    },
    overallScore(newVal, oldVal) {
      this.summaryScoreChartData = [newVal, 5];
    },
  },
  computed: {
    ...mapState({
      worthYourFocus: (state) => state.user.report["worthYourFocus"],
      report: (state) => state.user.report,
      narrativeText: (state) => state.user?.report?.narrativeText,
      overallScore: (state) =>
        state.user?.report?.summaryScores?.overall?.rating,
      SCText: (state) => state.user?.report?.narrativeText?.SC,
      naicsDrilldown: (state) => state.user.report["naicsDrilldown"],
      showYears: (state) => state.user.report.showYears,
      years: (state) => state.user.report.years,
      PLtable: (state) => state.user.report.tables["PL"],
      chartData: (state) => state.user.report.chartData["profitLoss"],
      chartDataBalanceSheet: (state) =>
        state.user.report.chartData["balanceSheet"],
      table: (state) => state.user.report.tables["PL"],
      tableBalanceSheet: (state) => state.user.report.tables["BS"],
      rolloverAux: (state) =>
        state.user.report.data[0].array_BB.array_lookup_ALL,
      summaryScores: (state) => state.user.report["summaryScores"],
      BSText: (state) => state.user?.report?.narrativeText?.BS,
      PLText: (state) => state.user?.report?.narrativeText?.PL,
      SCText: (state) => state.user?.report?.narrativeText?.SC,
      SUText: (state) => state.user?.report?.narrativeText?.SU,
      companyName: (state) => state.user?.companyName,
      developer: (state) => state.user?.report?.developerClient?.developer_name,
      releaseDisplay: (state) =>
        state?.user?.report?.release_display
          ? state?.user?.report?.release_display.replace("-", " ")
          : "",

      multiplesA: (state) => {
        return state.user.report["multiples_A"]
          ? state.user.report["multiples_A"]
          : [];
      },
      multiplesB: (state) => {
        return state.user.report["multiples_B"]
          ? state.user.report["multiples_B"]
          : [];
      },
      multiplesC: (state) => {
        return state.user.report["multiples_C"]
          ? state.user.report["multiples_C"]
          : [];
      },
      multiplesAll: (state) => {
        return state.user.report["multiples_all"]
          ? state.user.report["multiples_all"]
          : [];
      },
    }),
    filteredProfile() {
      return _.omit(this.report.data, "array_customer");
    },
    summaryScoresAll() {
      if (this.summaryScores) {
        let k;
        if ("ratios" in this.summaryScores && this.summaryScores.ratios) {
          k = this.summaryScores.ratios;
        } else {
          k = "";
        }

        return [this.summaryScores.overall, ...Object.values(k)];
      } else {
        return "";
      }
    },
    summaryScoresRatios() {
      if (this.summaryScores) {
        let k;
        if ("ratios" in this.summaryScores && this.summaryScores.ratios) {
          k = this.summaryScores.ratios;
        } else {
          k = "";
        }

        return [this.summaryScores.ratios, ...Object.values(k)];
      } else {
        return "";
      }
    },
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress($e) { },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      this.pdfLoading = true;

      this.$store.commit("user/SET_PDF_LOADING", true);

      let page1 = this.$refs.page1;
      let page2 = this.$refs.page2;
      let page3 = this.$refs.page3;
      let page4 = this.$refs.page4;
      let worthYourFocusPage = this.$refs.worthYourFocusPage;
      let page5 = this.$refs.page5;
      let page6 = this.$refs.page6;
      let page7 = this.$refs.page7;
      let page8 = this.$refs.page8;
      let page9 = this.$refs.page9;
      let page10 = this.$refs.page10;
      let page11 = this.$refs.page11;
      let page12 = this.$refs.page12;
      let page13 = this.$refs.page13;
      let page14 = this.$refs.page14;
      let page15 = this.$refs.page15;
      let page16 = this.$refs.page16;
      let page17 = this.$refs.page17;
      let page18 = this.$refs.page18;
      let page19 = this.$refs.page19;
      let page20 = this.$refs.page20;
      let page21 = this.$refs.page21;
      let page22 = this.$refs.page22;
      let page23 = this.$refs.page23;
      let page24 = this.$refs.page24;

      let pages = [
        page1,
        page2,
        page3,
        page4,
        worthYourFocusPage,
        page5,
        page6,
        page7,
        page8,
        page9,
        page10,
        page11,
        page12,
        page13,
        page14,
        page15,
        page16,
        page17,
        page18,
        page19,
        page20,
        page21,
        page22,
        page23,
        page24,
      ];

      options.pagebreak = {
        avoid: ".industry-location",
        mode: "css",
        after: ".br-after",
      };
      var worker = html2pdf()
        .set(options)
        .from(pages[0])
        .toPdf();
      pages.slice(1).forEach(function (page) {
        worker = worker
          .get("pdf")
          .then(function (pdf) {
            pdf.addPage();
          })
          .from(page)
          .toContainer()
          .toCanvas()
          .toPdf();
      });
      worker.get("pdf").then((pdf) => {
        if (this.$store.getters["user/pdfMustBeDownloaded"]) worker.save();
        else window.open(pdf.output("bloburl"), "_blank");
      });
    },
    async afterDownload() {
      this.pdfLoading = false;
      this.$store.commit("user/SET_PDF_LOADING", false);
    },
    init() {
      if (!this.showYears) {
        return;
      }

      let filtered_years = [];
      let me = this;

      if (this.showYears) {
        Object.keys(this.showYears).map((k) => {
          // this.showYears.forEach((s, i) => {

          if (this.showYears && this.showYears[k]) {
            filtered_years.push(this.years[k]);
          }
        });
      }
      if (!filtered_years || !filtered_years.length) {
        filtered_years = this.years;
      }
      filtered_years.forEach((s, i) => {
        this.filtered_years.push(Number(s));
      });
      this.tableData = Object.values(this.filteredProfile).filter((item) => {
        if (filtered_years.includes(item.year)) {
          return {
            ...item,
            firms: item.firms,
          };
        }
      });
      this.tableData.forEach((element) => {
        if (filtered_years.includes(element.year)) {
          this.filtered_firms.push(Number(element.firms));
        }
      });

      this.tableData = this.tableData.map((item) => {
        return {
          ...item,
          firms: me.numberWithCommas(item.firms),
        };
      });

      this.tableData = _.orderBy(this.tableData, ["year"], ["asc"]);
      let seriesFilter = [];
      Object.values(this.filteredProfile).forEach((item, index) => {
        if (filtered_years.includes(item.year)) {
          seriesFilter.push(item.firms);
        }
      });
      if (!seriesFilter || !seriesFilter.length) {
        seriesFilter = Object.values(this.filteredProfile).map(
          (item) => item.firms
        );
      }

      this.industrySummaryChart = {
        labels: filtered_years,
        series: [{ name: "Firms", data: seriesFilter.reverse() }],
      };

      if (
        this.report.displaySettings.includes("pl_balance_percent") &&
        this.report.displaySettings.includes("pl_balance_dollar")
      ) {
        this.display_by_dollars = true;
        this.display_by_percentages = true;
        this.display_by_variance = true;
      }
      if (
        this.report.displaySettings.includes("pl_balance_dollar") &&
        !this.report.displaySettings.includes("pl_balance_percent")
      ) {
        this.display_by_dollars = true;
        this.display_by_variance = true;
      }
      if (
        this.report.displaySettings.includes("pl_balance_percent") &&
        !this.report.displaySettings.includes("pl_balance_dollar")
      ) {
        this.display_by_percentages = true;
        this.display_by_variance = true;
      }
      if (
        !this.report.displaySettings.includes("pl_balance_percent") &&
        !this.report.displaySettings.includes("pl_balance_dollar")
      ) {
        this.display_by_dollars = false;
        this.display_by_percentages = false;
        this.display_by_variance = false;
      }

      if (!this.report.displaySettings.includes("pl_balance_percent"))
        this.display_by_percentages = false;

      if (!this.report.displaySettings.includes("pl_balance_dollar"))
        this.display_by_dollars = false;

      //this.switchView(section);
      //let filtered_years = [];
      this.showYears.forEach((s, i) => {
        if (s) {
          filtered_years.push(this.years[i]);
        }
      });
      if (!filtered_years.length) {
        filtered_years = this.years;
      }

      var rolloverArray = [];
      Object.entries(this.rolloverAux).forEach(([index, item]) => {
        rolloverArray[item.title] = item.description;
      });
      this.tableDataVarianceDollar = this.formatTable(
        this.table,
        "variance",
        "dollar",
        rolloverArray
      );
      this.tableDataVarianceDollar = this.tableDataVarianceDollar.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataVarianceDollar.forEach((element) => {
        this.newChartVarianceDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataVarianceDollarBalanceSheet = this.formatTable(
        this.tableBalanceSheet,
        "variance",
        "dollar",
        rolloverArray
      );
      this.tableDataVarianceDollarBalanceSheet = this.tableDataVarianceDollarBalanceSheet.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataVarianceDollarBalanceSheet.forEach((element) => {
        this.newChartVarianceDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataIndustryDollar = this.formatTable(
        this.table,
        "industry",
        "dollar",
        rolloverArray
      );
      this.tableDataIndustryDollar = this.tableDataIndustryDollar.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataIndustryDollar.forEach((element) => {
        this.newChartIndustryDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataIndustryDollarBalanceSheet = this.formatTable(
        this.tableBalanceSheet,
        "industry",
        "dollar",
        rolloverArray
      );
      this.tableDataIndustryDollarBalanceSheet = this.tableDataIndustryDollarBalanceSheet.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataIndustryDollarBalanceSheet.forEach((element) => {
        this.newChartIndustryDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataIndustryPercent = this.formatTable(
        this.table,
        "industry",
        "percent",
        rolloverArray
      );
      this.tableDataIndustryPercent = this.tableDataIndustryPercent.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataIndustryPercent.forEach((element) => {
        this.newChartIndustryPercentOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataIndustryPercentBalanceSheet = this.formatTable(
        this.tableBalanceSheet,
        "industry",
        "percent",
        rolloverArray
      );
      this.tableDataIndustryPercentBalanceSheet = this.tableDataIndustryPercentBalanceSheet.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataIndustryPercentBalanceSheet.forEach((element) => {
        this.newChartIndustryPercentOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataFirmDollar = this.formatTable(
        this.table,
        "firm",
        "dollar",
        rolloverArray
      );
      this.tableDataFirmDollar = this.tableDataFirmDollar.map((item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      });
      this.tableDataFirmDollar.forEach((element) => {
        this.newChartFirmDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataFirmDollarBalanceSheet = this.formatTable(
        this.tableBalanceSheet,
        "firm",
        "dollar",
        rolloverArray
      );
      this.tableDataFirmDollarBalanceSheet = this.tableDataFirmDollarBalanceSheet.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );
      this.tableDataFirmDollarBalanceSheet.forEach((element) => {
        this.newChartFirmDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });
      this.tableDataFirmPercent = this.formatTable(
        this.table,
        "firm",
        "percent",
        rolloverArray
      );
      this.tableDataFirmPercent = this.tableDataFirmPercent.map((item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });

        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      });
      this.tableDataFirmPercentBalanceSheet = this.formatTable(
        this.tableBalanceSheet,
        "firm",
        "percent",
        rolloverArray
      );
      this.tableDataFirmPercentBalanceSheet = this.tableDataFirmPercentBalanceSheet.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });

          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );
      this.tableDataFirmPercent.forEach((element) => {
        this.newChartFirmPercentOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataFirmPercentBalanceSheet.forEach((element) => {
        this.newChartFirmPercentOptionsBalanceSheet[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.charts = this.formatPieChart(this.chartData);
      this.charts = this.charts.filter(function (el) {
        return el.type === "dollar";
      });
      this.chartsBalanceSheet = this.formatPieChart(this.chartDataBalanceSheet);
      this.chartsBalanceSheet = this.chartsBalanceSheet.filter(function (el) {
        return el.type === "dollar";
      });
      // this.chartsChunks = this.charts.chunk(4);
      // this.chartsChunksBalanceSheet = this.chartsBalanceSheet.chunk(4);

      this.summaryChartData = {
        labels: [""],
        series: [[1, 1]],
      };
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return x;
      }
    },
    numberWithPoints(x) {
      if (typeof x === "number") {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else if (typeof x === "string") {
        return x.replace(/,/g, ".");
      } else {
        return x;
      }
    },
  },
};
</script>
